var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrdrHistoyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6042_44435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 18.75H11.25V22.5",
    stroke: "#150823",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6677 19.483C22.2705 20.6437 21.5014 21.641 20.4796 22.3199C19.4577 22.9989 18.2404 23.3216 17.0164 23.2381C15.7925 23.1546 14.6303 22.6694 13.7102 21.8579C12.7901 21.0464 12.1635 19.9539 11.9277 18.75",
    stroke: "#150823",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 15.75H23.25V12",
    stroke: "#150823",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.832 15.018C12.2292 13.8573 12.9984 12.8601 14.0202 12.1811C15.042 11.5022 16.2594 11.1794 17.4833 11.2629C18.7073 11.3465 19.8695 11.8316 20.7896 12.6431C21.7097 13.4546 22.3362 14.5471 22.572 15.751",
    stroke: "#150823",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25036 14.25C7.42436 14.2501 6.61427 14.0228 5.90886 13.5931C5.20345 13.1633 4.62992 12.5477 4.25112 11.8137C3.87231 11.0797 3.70284 10.2556 3.76128 9.43165C3.81971 8.60772 4.1038 7.81577 4.58241 7.14256C5.06102 6.46935 5.71569 5.94087 6.47469 5.615C7.23369 5.28913 8.06774 5.17845 8.88546 5.2951C9.70319 5.41174 10.473 5.7512 11.1106 6.27629C11.7483 6.80137 12.2291 7.49183 12.5004 8.272",
    stroke: "#150823",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 9.75H8.25V8.25",
    stroke: "#150823",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 20.25H2.25C1.85218 20.25 1.47064 20.092 1.18934 19.8107C0.908035 19.5294 0.75 19.1478 0.75 18.75V2.25C0.75 1.85218 0.908035 1.47064 1.18934 1.18934C1.47064 0.908035 1.85218 0.75 2.25 0.75H12.879C13.2767 0.75035 13.658 0.908615 13.939 1.19L16.811 4.061C16.9503 4.20036 17.0607 4.36578 17.136 4.54783C17.2114 4.72988 17.2501 4.92498 17.25 5.122V7.5",
    stroke: "#150823",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6042_44435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdrHistoyIcon);
export default __webpack_public_path__ + "static/media/ordr-histoy-icon.2f8b7e12d363f83a0fc7cceaccc9613f.svg";
export { ForwardRef as ReactComponent };